import { Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { AppRouter } from './AppRouter';
import { AgentsProvider } from '@/contexts/AgentsContext';
import { NotableJobInstanceCountsProvider } from '@/contexts/NotableJobInstanceCountsContext';
import { StateMessage } from './StateMessage';
import { ChildWindowRequestHandler } from './ChildWindowRequestHandler';
import { ChildWindowLauncher } from './ChildWindowLauncher';
import { shouldRelaunchInNewWindow } from '@/utils/win';
import { JobConfigCountsProvider } from '@/contexts/JobConfigCountsContext';
import { TenantUsersProvider } from '@/providers/TenantUsersProvider';

export const Private = () => (
  <>
    <ChildWindowRequestHandler />
    {
      // Check if we can render the UI contents. If we're in an iframe and the feature flag
      // to escape iframes is true, we shouldn't render, we should wait while another window opens.
      // Otherwise, it's fine to render the UI now.
      shouldRelaunchInNewWindow() ? (
        <ChildWindowLauncher />
      ) : (
        <ErrorBoundary fallback={<StateMessage isError title="Error loading personas." />}>
          <Suspense fallback={<StateMessage isLoading title="Loading personas..." />}>
            <AgentsProvider>
              <TenantUsersProvider>
                <NotableJobInstanceCountsProvider>
                  <JobConfigCountsProvider>
                    <ErrorBoundary fallback={<div>Something went wrong.</div>}>
                      <Suspense fallback="Loading...">
                        <AppRouter />
                      </Suspense>
                    </ErrorBoundary>
                  </JobConfigCountsProvider>
                </NotableJobInstanceCountsProvider>
              </TenantUsersProvider>
            </AgentsProvider>
          </Suspense>
        </ErrorBoundary>
      )
    }
  </>
);
